"use strict";

exports.__esModule = true;
exports.utmParser = exports.buildFromFlatObject = void 0;

const utmParser = queryParams => {
  return fillUtmParameters(queryParams);
};

exports.utmParser = utmParser;

const fillUtmParameters = data => {
  const utmParameters = { ...setUtmParameter(data, 'utmmedium', 'utm_medium='),
    ...setUtmParameter(data, 'utmsource', 'utm_source='),
    ...setUtmParameter(data, 'utmterm', 'utm_term='),
    ...setUtmParameter(data, 'utmcontent', 'utm_content='),
    ...setUtmParameter(data, 'utmcampaign', 'utm_campaign='),
    ...setUtmParameter(data, 'utmartid', 'utm_artid='),
    ...setUtmParameter(data, 'utminternal', 'utm_internal='),
    ...setUtmParameter(data, 'utmprsid', 'utm_prsid='),
    ...setUtmParameter(data, 'utmcid', 'utm_cid='),
    ...{
      dynamicFields: { ...setUtmParameter(data, 'utmartid', 'utm_artid=')
      }
    }
  };
  return utmParameters;
};

function setUtmParameter(data, dataKey, urlKey) {
  let utm;

  if (data) {
    const utmParamIndex = data.indexOf(urlKey);

    if (utmParamIndex >= 0) {
      utm = data.substring(utmParamIndex + urlKey.length, data.length);

      if (utm.indexOf('&') >= 0) {
        utm = utm.substring(0, utm.indexOf('&'));
      }
    }

    return {
      [dataKey]: utm
    };
  }
}

const propertyNames = {
  accessloginshown: 'accessLoginShown',
  accesswalltype: 'accessWallType'
};

const buildFromFlatObject = utmObject => {
  let finalUtm = {
    utmmedium: utmObject.utm_medium || utmObject.ref_utm_medium || undefined,
    utmsource: utmObject.utm_source || utmObject.ref_utm_source || undefined,
    utmterm: utmObject.utm_term || utmObject.ref_utm_term || undefined,
    utmcontent: utmObject.utm_content || utmObject.ref_utm_content || undefined,
    utmcampaign: utmObject.utm_campaign || utmObject.ref_utm_campaign || undefined,
    utmartid: utmObject.utm_artid || utmObject.ref_utm_artid || undefined,
    utminternal: utmObject.utm_internal || utmObject.ref_utm_internal || undefined,
    utmprsid: utmObject.utm_prsid || utmObject.ref_utm_prsid || undefined,
    utmcid: utmObject.utm_cid || utmObject.ref_utm_cid || undefined,
    // Should be deprecated - confirmation from traffic db required that this is not used in a query
    dynamicFields: {
      utmartid: utmObject.utm_artid || utmObject.ref_utm_artid || undefined
    }
  };
  return finalUtm;
};

exports.buildFromFlatObject = buildFromFlatObject;